import { smartLockerPackageConstants } from "@constants";
import { smartLockerPackageService } from "@services";

export const smartLockerPackageActions = {
  /**
   * 取得智慧櫃包裹紀錄列表
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: smartLockerPackageConstants.GET_ALL_REQUEST
      });

      smartLockerPackageService.getAll(constructionUuid, condition).then(
        ({ config, statistics, items, total }) => {
          dispatch({
            type: smartLockerPackageConstants.GET_ALL_SUCCESS,
            constructionUuid,
            config,
            statistics,
            items,
            total,
            condition
          });
        },
        error => {
          dispatch({
            type: smartLockerPackageConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重置訪客紀錄列表
   * @returns
   */
  resetAll: () => ({
    type: smartLockerPackageConstants.RESET_ALL_SUCCESS
  })
};
